module.exports = __webpack_public_path__ + "img/activity-squce.da08238d.png";